<template>
    <tbody>
    <tr :class="[{more_info: $_loggedUser_action_allowed('brandDomains', 'update'), open: isOpen }]" @click="toggleMoreInfo()">
      <td class="no_padding drag_drop"><span></span></td>
      <td class="no_padding">
        <input type="checkbox"
               :id="entity.id"
               :value="entity.id"
               @click.stop
               @change="onChange"
               :checked="isChecked"
        />
        <label
            :for="entity.id"
            @click.stop
            v-translate>Vybrat
        </label>
      </td>
        <td data-th="Doména" class="first_data">{{ entity.domain }}</td>
        <td data-th="CSS Kód">{{ entity.css_code }}</td>
        <td data-th="Vytvořeno" class="last_data" v-html="$_date_formatFull(entity.date_created)"></td>
        <td data-th="Upraveno" class="last_data" v-html="$_date_formatFull(entity.date_updated)"></td>
        <td class="no_padding edit">
            <div class="edit_inner">
                <a
                    v-if="$_loggedUser_action_allowed('brandDomains', 'delete')"
						class="btn btn_action btn_delete"
            :title="'Smazat' | translate"
						@click.stop.prevent="emitDeleteDomain">
                    <translate class="translate">Smazat</translate>
				</a>
            </div>
        </td>
    </tr>

    <tr :class="['more_info_content', { open: isOpen }]">
      <td></td>
      <td></td>
        <td class="first_data">
            <text-input :id="domainDomainInputId" v-model="entity.domain" :required="true" ref="domainref">
                <translate class="translate">Doména</translate>
            </text-input>
        </td>
        <td>
            <text-input :id="domainCssCodeInputId" v-model="entity.css_code">
                <translate class="translate">CSS kód</translate>
            </text-input>
        </td>
        <td><p>
			<input
					class="btn"
					type="submit"
					:value="'Uložit' | translate"
					@click.stop.prevent="emitUpdateDomain">
		</p></td>
        <td class="first_data"><p></p></td>
        <td class="first_data"><p></p></td>
    </tr>
    </tbody>
</template>

<script>
import message from "@/components/mixins/message"
import rowActions from "@/components/mixins/row-actions"

	export default {
		name: "DomainRow",
    mixins: [message, rowActions],
		data: function () {
			return {
				isOpen: false
			}
		},
		props: {
			entity: Object,
		},
		computed: {
			domainDomainInputId() {
				return 'domain-name-' + this.entity.id
			},
			domainCssCodeInputId() {
				return 'domain-csscode-' + this.entity.id
			},
		},
		methods: {
			toggleMoreInfo() {
        if(this.$_updateActionAllowed) {
          this.isOpen = !this.isOpen

          if (this.isOpen) {
            this.$emit("opened", this.entity.id);
          }
        }
			},
      closeMoreInfo() {
        this.isOpen = false;
      },
			emitDeleteDomain() {
				this.$emit('deleteDomain', this.entity.id)
			},
			emitUpdateDomain() {
        this.$refs["domainref"].setForcedInvalid(false);

        if (!this.entity.domain) {
          this.$refs["domainref"].setForcedInvalid(true, "Doména musí být vyplněna")
        } else if (this.entity.domain.length < 2) {
          this.$refs["domainref"].setForcedInvalid(true, "Doména musí mít alespoň 2 znaky")
        } else {
          this.$emit('updateDomain', {...this.entity}, this)
        }
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/brands/forms/DomainRow.vue